import React, { Component } from 'react'
import M from  'materialize-css/dist/js/materialize.min.js';
import 'materialize-css/dist/css/materialize.min.css';
class SelectPublisher extends Component {


    componentDidMount(){
        var elems = document.querySelectorAll('select');
        M.FormSelect.init(elems, {});
 }
    render() {   
        // console.log(this.props.selctedID)selected={(this.props.pub.id===this.props.selctedID)
        return (
          <option id={this.props.pub.id} value={this.props.pub.id}> {this.props.pub.name}</option> 
          
        )
    }
   
}

export default SelectPublisher;
